import { isSessionAuthenticated } from 'utils/sessionTokens';

const VerifyToken = () => isSessionAuthenticated();

export default VerifyToken;
